
import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

import { jwtDecode, JwtPayload } from 'jwt-decode';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

	private authService = inject(AuthService);
	private router = inject(Router);

	constructor() { }

	canActivate(): boolean {
		const token = localStorage.getItem('token'); // o sessionStorage

		if (!token) {
			return this.logout();
		}

		try {
			const decoded = jwtDecode<JwtPayload>(token);
			if (!decoded || !decoded.exp) return this.logout();

			const isExpired = decoded.exp * 1000 < Date.now();
			if (isExpired) return this.logout();

			this.authService.is_logged_in.set(true);
			return true;
		} catch (error) {
			// Token corrupto o formato inválido
			return this.logout();
		}
		/*
		if (token) {
			// Aquí podrías validar el JWT (expiración, firma, etc.)
			this.authService.is_logged_in.set(true);
			return true;
		} else {
			this.authService.is_logged_in.set(false);
			this.router.navigate(['/login'], { replaceUrl: true });
			return false;
		}
		*/
	}

	logout():boolean {
		localStorage.removeItem('token');
		this.authService.is_logged_in.set(false);
		this.router.navigate(['/login'], { replaceUrl: true });
		return false;
	}
}
